"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yellowLight = exports.yellowDark = exports.yellow800 = exports.yellow400 = exports.yellow300 = exports.yellow200 = exports.yellow10 = exports.yellow = exports.white = exports.teal500 = exports.teal50 = exports.teal200 = exports.teal100 = exports.redDark = exports.red700 = exports.red400 = exports.red200 = exports.red10 = exports.red = exports.purple600 = exports.purple400 = exports.purple300 = exports.purple200 = exports.purple10 = exports.purple = exports.muted = exports.greenDark = exports.green800 = exports.green400 = exports.green300 = exports.green200 = exports.green10 = exports.green = exports.grayLightest = exports.grayLighter = exports.grayLight = exports.grayDarkest = exports.grayDarker = exports.grayDark = exports.gray900 = exports.gray800 = exports.gray700 = exports.gray600 = exports.gray500 = exports.gray50 = exports.gray400 = exports.gray300 = exports.gray200 = exports.gray100 = exports.gray = exports.gfhRed = exports.gfhGreen = exports.gfhBlue = exports.darkBlue900 = exports.darkBlue800 = exports.darkBlue700 = exports.darkBlue400 = exports.darkBlue300 = exports.darkBlue100 = exports.darkBlue10 = exports.blueLightBorder = exports.blueLight = exports.blueHover = exports.blueGray700 = exports.blueGray500 = exports.blueGray50 = exports.blueGray400 = exports.blueGray300 = exports.blueGray100 = exports.blueGray10 = exports.blueDarkTheme = exports.blueDark = exports.blueContact = exports.blueBorder = exports.blue800 = exports.blue700 = exports.blue500 = exports.blue400 = exports.blue300 = exports.blue200 = exports.blue10 = exports.blue = exports.blackDark = exports.black = void 0;
// New color palette
// blue
var blue800 = '#2a57ec';
exports.blue800 = blue800;
var blue700 = '#206cff';
exports.blue700 = blue700;
var blue500 = '#008dff';
exports.blue500 = blue500;
var blue400 = '#558FFF';
exports.blue400 = blue400;
var blue300 = '#4fb1ff';
exports.blue300 = blue300;
var blue200 = '#89c8ff';
exports.blue200 = blue200;
var blue10 = '#e6f3ff'; // dark blue

exports.blue10 = blue10;
var darkBlue900 = '#10275B';
exports.darkBlue900 = darkBlue900;
var darkBlue800 = '#1b3772';
exports.darkBlue800 = darkBlue800;
var darkBlue700 = '#0B1A3B';
exports.darkBlue700 = darkBlue700;
var darkBlue400 = '#344773';
exports.darkBlue400 = darkBlue400;
var darkBlue300 = '#57678C';
exports.darkBlue300 = darkBlue300;
var darkBlue100 = '#BDBECD';
exports.darkBlue100 = darkBlue100;
var darkBlue10 = '#D4D8E1'; // teal

exports.darkBlue10 = darkBlue10;
var teal500 = '#14C4CA';
exports.teal500 = teal500;
var teal200 = '#89E1E4';
exports.teal200 = teal200;
var teal100 = '#B8EDEF';
exports.teal100 = teal100;
var teal50 = '#E7F9F9'; // red

exports.teal50 = teal50;
var red700 = '#d40033';
exports.red700 = red700;
var red400 = '#ef3f54';
exports.red400 = red400;
var red200 = '#ee939b';
exports.red200 = red200;
var red10 = '#fff8f9'; // green

exports.red10 = red10;
var green800 = '#00782e';
exports.green800 = green800;
var green400 = '#2eb769';
exports.green400 = green400;
var green300 = '#5dc483';
exports.green300 = green300;
var green200 = '#8fd4a7';
exports.green200 = green200;
var green10 = '#eef6f4'; // yellow

exports.green10 = green10;
var yellow800 = '#ff8a00';
exports.yellow800 = yellow800;
var yellow400 = '#fec802';
exports.yellow400 = yellow400;
var yellow300 = '#ffdf6b';
exports.yellow300 = yellow300;
var yellow200 = '#fede7b';
exports.yellow200 = yellow200;
var yellow10 = '#fef9e5'; // purple

exports.yellow10 = yellow10;
var purple600 = '#8d24aa';
exports.purple600 = purple600;
var purple400 = '#ab47bc';
exports.purple400 = purple400;
var purple300 = '#ba68c8';
exports.purple300 = purple300;
var purple200 = '#ce93d8';
exports.purple200 = purple200;
var purple10 = '#eee4f3'; // gray

exports.purple10 = purple10;
var gray900 = '#212121';
exports.gray900 = gray900;
var gray800 = '#424242';
exports.gray800 = gray800;
var gray700 = '#616161';
exports.gray700 = gray700;
var gray600 = '#757575';
exports.gray600 = gray600;
var gray500 = '#9e9e9e';
exports.gray500 = gray500;
var gray400 = '#bdbdbd';
exports.gray400 = gray400;
var gray300 = '#e0e0e0';
exports.gray300 = gray300;
var gray200 = '#eeeeee';
exports.gray200 = gray200;
var gray100 = '#f5f5f5';
exports.gray100 = gray100;
var gray50 = '#fafafa'; // blueGray

exports.gray50 = gray50;
var blueGray700 = '#2B3A47';
exports.blueGray700 = blueGray700;
var blueGray500 = '#3e4e5d';
exports.blueGray500 = blueGray500;
var blueGray400 = '#77838D';
exports.blueGray400 = blueGray400;
var blueGray300 = '#949FA8';
exports.blueGray300 = blueGray300;
var blueGray100 = '#B7BECD';
exports.blueGray100 = blueGray100;
var blueGray50 = '#F3F5F7';
exports.blueGray50 = blueGray50;
var blueGray10 = '#F5F9FF'; // white

exports.blueGray10 = blueGray10;
var white = '#ffffff'; // Legacy color palette
// blue

exports.white = white;
var blue = blue700;
exports.blue = blue;
var blueBorder = '#239ed8';
exports.blueBorder = blueBorder;
var blueDark = blue700;
exports.blueDark = blueDark;
var blueHover = '#085174';
exports.blueHover = blueHover;
var blueContact = '#a8d5eb';
exports.blueContact = blueContact;
var blueLight = '#d4ecf7';
exports.blueLight = blueLight;
var blueLightBorder = '#48bdf3';
exports.blueLightBorder = blueLightBorder;
var blueDarkTheme = '#4bbdf3'; // gray scale

exports.blueDarkTheme = blueDarkTheme;
var black = gray900;
exports.black = black;
var blackDark = '#000000';
exports.blackDark = blackDark;
var grayDarkest = '#515c61';
exports.grayDarkest = grayDarkest;
var grayDarker = '#556268';
exports.grayDarker = grayDarker;
var grayDark = blueGray400;
exports.grayDark = grayDark;
var muted = blueGray500;
exports.muted = muted;
var gray = '#d1d8db';
exports.gray = gray;
var grayLight = '#e3e8eb';
exports.grayLight = grayLight;
var grayLighter = '#eef1f3';
exports.grayLighter = grayLighter;
var grayLightest = '#f4f6f7'; // basic

exports.grayLightest = grayLightest;
var green = green400;
exports.green = green;
var greenDark = '#4aa666';
exports.greenDark = greenDark;
var yellow = yellow400;
exports.yellow = yellow;
var yellowLight = '#ffe9ab';
exports.yellowLight = yellowLight;
var yellowDark = '#dfa600';
exports.yellowDark = yellowDark;
var red = red400;
exports.red = red;
var redDark = '#e02a2a';
exports.redDark = redDark;
var purple = purple400; // gfh colors

exports.purple = purple;
var gfhBlue = '#1B74DA';
exports.gfhBlue = gfhBlue;
var gfhGreen = '#2FCFAC';
exports.gfhGreen = gfhGreen;
var gfhRed = '#E75C66';
exports.gfhRed = gfhRed;